import posthog from "posthog-js";
import { env } from "~/env.mjs";
import { hasBrowserAnalyticsConsent } from "~/lib/consent-region";

export { posthog };

export function getPostHogSupportSessionId(): string | undefined {
  if (!isPostHogBrowserEnabled() || !hasBrowserAnalyticsConsent()) return;
  try {
    return posthog.get_session_id() || undefined;
  } catch {
    // Support remains available if analytics is blocked or uninitialized.
    return undefined;
  }
}

export function isPostHogBrowserEnabled(): boolean {
  return (
    typeof window !== "undefined" &&
    env.NEXT_PUBLIC_VERCEL_ENV === "production" &&
    !env.NEXT_PUBLIC_DEPLOYMENT_URL.includes("localhost") &&
    Boolean(env.NEXT_PUBLIC_POSTHOG_API_KEY) &&
    Boolean(env.NEXT_PUBLIC_POSTHOG_HOST)
  );
}

// Without analytics consent these events are anonymous (memory
// persistence, no person profile, no account linking). Consent only adds
// the persistent identity; identify() is gated in PostHogAppProvider.
export function capturePostHogEvent(
  event: string,
  properties?: Record<string, unknown>,
): void {
  posthog.capture(event, properties);
}
